(function () {
  function updateGiftAttr(checked) {
    const body = {
      attributes: { gift: checked ? 'yes' : '' }
    };
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
      credentials: 'same-origin'
    }).catch(() => {});
  }

  function syncAll(checked) {
    document.querySelectorAll('input[name="attributes[gift]"]').forEach(inp => {
      if (inp.checked !== checked) inp.checked = checked;
    });
  }

  document.addEventListener('change', (e) => {
    const t = e.target;
    if (t && t.matches('input[name="attributes[gift]"]')) {
      const checked = !!t.checked;
      syncAll(checked);
      updateGiftAttr(checked);
    }
  });
})();
